module.exports = __webpack_public_path__ + "images/8e6c956fff8ffaa1430d2513d7814718.png";